import { Intents } from "@certa/studio-core/src/constants/activityLogs.constants";
import { dbOps } from "../hooks/dbOps.store";
import type {
  EventRule,
  StateRule
} from "@certa/studio-core/src/types/eca.types";
import type { ProcessProps } from "@certa/studio-core";

export const addEventRule = (props: {
  processId: string;
  eventRule: EventRule;
}) => {
  const { processId, eventRule } = props;

  dbOps().transaction(
    () => {
      const process = dbOps().getProcessDef(processId);
      if (!process) {
        throw new Error("Process not found");
      }
      const updatedProcess: ProcessProps = {
        ...process.process,
        eventRuleSequence: [
          ...(process.process?.eventRuleSequence ?? []),
          eventRule.__studioId
        ]
      };
      dbOps().updateProcess(process.process.id, updatedProcess);
      dbOps().addEventRule(processId, eventRule);
    },
    { intent: Intents.ADD_EVENT_RULE }
  );
};

export const addStateRule = (props: {
  processId: string;
  stateRule: StateRule;
}) => {
  const { processId, stateRule } = props;

  dbOps().transaction(
    () => {
      const process = dbOps().getProcessDef(processId);
      if (!process) {
        throw new Error("Process not found");
      }
      const updatedProcess: ProcessProps = {
        ...process.process,
        stateRuleSequence: [
          ...(process.process?.stateRuleSequence ?? []),
          stateRule.__studioId
        ]
      };
      dbOps().updateProcess(process.process.id, updatedProcess);
      dbOps().addStateRule(processId, stateRule);
    },
    { intent: Intents.ADD_STATE_RULE }
  );
};

export const updateEventRule = (props: {
  processId: string;
  eventRule: EventRule;
}) => {
  const { processId, eventRule } = props;

  dbOps().transaction(
    () => {
      dbOps().updateEventRule(processId, eventRule);
    },
    { intent: Intents.UPDATE_EVENT_RULE }
  );
};

export const updateStateRule = (props: {
  processId: string;
  stateRule: StateRule;
}) => {
  const { processId, stateRule } = props;

  dbOps().transaction(
    () => {
      dbOps().updateStateRule(processId, stateRule);
    },
    { intent: Intents.UPDATE_STATE_RULE }
  );
};

export const removeEventRule = (props: {
  processId: string;
  eventRuleId: string;
}) => {
  const { processId, eventRuleId } = props;

  dbOps().transaction(
    () => {
      const process = dbOps().getProcessDef(processId);
      if (!process) {
        throw new Error("Process not found");
      }
      const updatedProcess: ProcessProps = {
        ...process.process,
        eventRuleSequence: process.process.eventRuleSequence.filter(
          id => id !== eventRuleId
        )
      };
      dbOps().updateProcess(process.process.id, updatedProcess);
      dbOps().removeEventRule(processId, eventRuleId);
    },
    { intent: Intents.DELETE_EVENT_RULE }
  );
};

export const removeStateRule = (props: {
  processId: string;
  stateRuleId: string;
}) => {
  const { processId, stateRuleId } = props;

  dbOps().transaction(
    () => {
      const process = dbOps().getProcessDef(processId);
      if (!process) {
        throw new Error("Process not found");
      }
      const updatedProcess: ProcessProps = {
        ...process.process,
        stateRuleSequence: process.process.stateRuleSequence.filter(
          id => id !== stateRuleId
        )
      };
      dbOps().updateProcess(process.process.id, updatedProcess);
      dbOps().removeStateRule(processId, stateRuleId);
    },
    { intent: Intents.DELETE_STATE_RULE }
  );
};
